<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import HelpSection from "../components/HelpSection.svelte";
	import Contact from "../components/Contact.svelte";
	import DecoratedHeadline from "../components/DecoratedHeadline.svelte";
	import BlogPosts from "../components/BlogPosts.svelte";
	import Icon from "../components/Icon.svelte";
	import SimilarReferences from "../components/References/SimilarReferences.svelte";
	import arrowLeft from "../../../core/assets/icons/filled-arrow-left.svg?raw";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import ServiceImageCarousel from "../components/ServiceImageCarousel.svelte";
	import type { PublishedBlogPost } from "../../../core/schema/BlogPost.js";
	import type { PublishedCaseStudy } from "../../../core/schema/CaseStudy.js";
	import Link from "./Link.svelte";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { contactPathMap } from "../../../core/schema/paths/contactPathMap.js";
	import ServiceList from "./ServiceList.svelte";
	import { servicesAnchorPathMap } from "../../../core/schema/paths/servicesAnchorPathMap";

	export let heading: string;
	export let title: string;
	export let perex: string;
	export let perex2: string;
	export let images: string[];
	export let references: PublishedCaseStudy[];
	export let blogPosts: PublishedBlogPost[];

	const { TENANT_LOCALE } = getGlobalSettings();
</script>

<Layout>
	<button
		class="ml-6 mt-4 flex cursor-pointer gap-4 md:ml-10 md:mt-8"
		on:click={() => {
			window.location.href = `/${servicesAnchorPathMap[TENANT_LOCALE]}`;
		}}
	>
		<Icon icon={arrowLeft} class="text-gray h-4 w-4" />
		<span class="text-xs font-extrabold">Zpět</span>
	</button>

	<DecoratedHeadline h1 class="mt-7">
		{#each heading.split("\n") as headingPart}
			{nbspify(headingPart)}
			<br />
		{/each}
	</DecoratedHeadline>
	<div class="mx-auto mb-20 mt-16 flex max-w-[73rem] flex-col items-center gap-8 px-4 text-center lg:px-8">
		<p class="text-lg font-bold text-gray-400 lg:text-xl">
			{#each title.split("\n") as titlePart}
				{nbspify(titlePart)}
				<br />
			{/each}
		</p>
		<p class="text-bito-black text-md font-extrabold lg:text-[1.5rem]">
			{#each perex.split("\n") as perexPart}
				{nbspify(perexPart)}
				<br />
			{/each}
		</p>
		<p class="text-bito-black text-xs tracking-[0.005em] lg:text-base">
			{#each perex2.split("\n") as perexPart}
				{nbspify(perexPart)}
				<br />
			{/each}
		</p>
		<Link asButton href="/{contactPathMap[TENANT_LOCALE]}" class="w-[13.75rem]">{nbspify("Kontaktujte nás")}</Link>
	</div>

	<div class="mb-20">
		<ServiceImageCarousel photoGallery={images} />
	</div>

	<slot />

	<p class="mx-auto max-w-[68rem] text-center text-lg font-bold text-gray-400 lg:text-xl">
		{nbspify(
			"Máte zájem o naše služby? Vyplňte formulář a naši odborníci si s vámi domluví schůzku, kde všechno proberete!",
		)}
	</p>

	<div class="container mt-20 flex flex-col items-center gap-20 lg:mt-32 lg:gap-32">
		<Contact />
		{#if references.length > 0}
			<SimilarReferences similarReferences={references} title="Naše reference" />
		{/if}
		<BlogPosts {blogPosts} title="Doporučujeme" />
		<HelpSection />
		<div class="grid grid-cols-2 items-start justify-center gap-4 px-4 lg:grid-cols-4 lg:gap-6">
			<ServiceList />
		</div>
	</div>
</Layout>
